import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Row, Col } from 'react-grid-system';
import { TabbarWrapper, DaysMenu } from './styles';
import TabPanel from './TabPanel';
import * as types from '../../constants';
import Dropdown from '../shared/Dropdown';
import IconFont from '../shared/IconFont';
import CupCalendarTabbar from '../CupCalendarTabbar';
import { getQuery } from '../../helpers';
import { isBasketCup } from '../../common/rcs_gaz_mc_core_FE';

class CalendarTabbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
      liFirst: false,
      liLast: false,
      hasScroll: false,
      currentPhase: null,
      currentSubPhase: null,
    };
    //this.ref = React.createRef();
    this.ref = React.createRef();
    this.commonStyle = {
      zIndex: 1, position: 'absolute', top: 0, width: '50px',
    };
  }

  componentDidMount() {
    this.resizeCallback();
    window.addEventListener('resize', this.resizeCallback);
    const {
      isCup,
      isTennis,
      isVolleyChampionship,
      isBasketChampionship,
      isFootballChampionship,
      isRugby, isBasketSerieA,
      isFootballExtChampionship,
      isFootballSerieB,
    } = this.props;
    const { competitionId } = window.matchcenterPage;
    if (
      (
        (!isVolleyChampionship && !isFootballExtChampionship && !isTennis && !isBasketChampionship && !isBasketSerieA && !isRugby && !isFootballChampionship && !isFootballSerieB)
        || isCup
        || isBasketCup(competitionId)
      ) && document.querySelector('#root-header')) {
      document.querySelector('#root-header').style.display = 'none';
    }
  }

  componentWillReceiveProps(nextProps) {
    const queryObj = getQuery(document.location);
    let { currentPhase, currentSubPhase } = this.state;
    if (queryObj && (queryObj.giornata || queryObj.fase)) {
      if (queryObj.giornata) {
        if (nextProps.isRugby || nextProps.isBasketSerieA || nextProps.isFootballSerieB) {
          currentPhase = 'regularSeason';
        } else {
          currentPhase = 'regular-season';
        }
      } else if (queryObj.fase) {
        currentPhase = queryObj.fase;
        if (queryObj.subfase) {
          currentSubPhase = queryObj.subfase;
        }
      }
    } else {
      currentPhase = nextProps.cupTabbar.getIn(['lastPhase', 'label']);
      currentSubPhase = nextProps.cupTabbar.get('lastSubPhase');
    }
    this.setState({
      currentPhase, currentSubPhase,
    });
  }

  componentDidUpdate() {
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
  }

  setActiveTab = (tab) => {
    const { isFootballSerieB } = this.props;
    const qs = isFootballSerieB ? `fase=regularSeason&giornata=${tab}` : `giornata=${tab}`;
    window.location.replace(`${window.location.origin}${window.location.pathname}?${qs}`);
    // const { sportId, competitionId, seasonId } = window.matchcenterPage;
    // this.props.actions.getCalendar(sportId, competitionId, tab, seasonId);
  };

  setTennisPhase = (tab) => {
    window.location.replace(`${window.location.origin}${window.location.pathname}?fase=${tab}`);
    // this.props.actions.setTennisPhase(tab);
  };

  moveLeft = (currentDay) => {
    if (currentDay > 1) {
      const { isFootballSerieB } = this.props;
      const qs = isFootballSerieB ? `fase=regularSeason&giornata=${currentDay - 1}` : `giornata=${currentDay - 1}`;
      window.location.replace(`${window.location.origin}${window.location.pathname}?${qs}`);
      // const { sportId, competitionId, seasonId } = window.matchcenterPage;
      // this.props.actions.getCalendar(sportId, competitionId, currentDay - 1, seasonId);
    }
  };

  moveRight = (currentDay, totalDays) => {
    if (currentDay < totalDays) {
      const { isFootballSerieB } = this.props;
      const qs = isFootballSerieB ? `fase=regularSeason&giornata=${currentDay + 1}` : `giornata=${currentDay + 1}`;
      window.location.replace(`${window.location.origin}${window.location.pathname}?${qs}`);
      // const { sportId, competitionId, seasonId } = window.matchcenterPage;
      // this.props.actions.getCalendar(sportId, competitionId, currentDay + 1, seasonId);
    }
  };

  generateRounds = (days) => {
    const rounds = [];
    if (days) {
      for (let i = 1; i <= days; i += 1) { rounds.push(i); }
    }
    return rounds;
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 1023,
    });
  };

  scroll_button = (dir) => {
    const ul_rect = this.ref.getBoundingClientRect();
    const scroll = Math.floor(ul_rect.width / 2);
    let scrollAmount = 0;
    const step = 8;
    const slideTimer = setInterval(() => {
      if (dir === 'next') {
        this.ref.scrollLeft += step;
      } else {
        this.ref.scrollLeft -= step;
      }
      scrollAmount += step;
      if (scrollAmount >= scroll) {
        window.clearInterval(slideTimer);
      }
    }, 20);
  }

  scrollCenterMenu = () => {
    if (this.state.hasScroll) {
      return;
    }
    const li_active = Array.from(this.ref.children).findIndex(obj => obj.classList.contains('tab-active'));
    if (li_active > 0) {
      const li_active_rect = this.ref.children[li_active].getBoundingClientRect();
      let pos = li_active_rect.left + Math.round(li_active_rect.width / 2);
      const ulWidth = this.ref.getBoundingClientRect().width;
      pos = (pos + this.ref.scrollLeft) - Math.round(ulWidth / 2);
      this.ref.scrollLeft = pos;
      this.setState({ hasScroll: true });
    }
  };

  handleScroll = () => {
    if (!this.ref.children) {
      return;
    }
    const len = this.ref.children.length;
    if (len > 0) {
      const ul_rect = this.ref.getBoundingClientRect();
      const li_last_rect = this.ref.children[len - 1].getBoundingClientRect();
      // uscita nel caso di menu corto
      if (Math.floor(ul_rect.right) > Math.floor(li_last_rect.right) && !this.state.hasScroll) {
        return;
      }
      this.scrollCenterMenu();
      const li_first_rect = this.ref.children[0].getBoundingClientRect();
      if (((ul_rect.left - 10) > li_first_rect.left) && this.state.liFirst === false) { this.setState({ liFirst: true }); }
      if (((ul_rect.left - 10) <= li_first_rect.left) && this.state.liFirst === true) { this.setState({ liFirst: false }); }

      if (((ul_rect.right + 10) <= li_last_rect.right) && this.state.liLast === false) { this.setState({ liLast: true }); }
      if (((ul_rect.right + 10) > li_last_rect.right) && this.state.liLast === true) { this.setState({ liLast: false }); }
    }
  }

  spanPrevStyle = (liState) => {
    const style = Object.assign({
      left: '-5px',
      paddingLeft: '5px',
      textAlign: 'left',
      background: 'linear-gradient(270deg, rgba(253,233,235,0) 20%,#fde9eb 50%)',
    }, this.commonStyle);
    if (!liState) {
      style.display = 'none';
    }
    return style;
  }

  spanNextStyle = (liState) => {
    const style = Object.assign({
      right: '-5px',
      paddingRight: '5px',
      textAlign: 'right',
      background: 'linear-gradient(90deg, rgba(253,233,235,0) 0%,#fde9eb 70%)',
    }, this.commonStyle);
    if (!liState) {
      style.display = 'none';
    }
    return style;
  }

  render() {
    const {
      currentDay,
      totalDays,
      dictionary,
      isCup,
      isMotorSport,
      tennisTabbar,
      isTennis,
      currentTennisPhase,
      isCycling,
      isVolley,
      isVolleyChampionship,
      isBasketChampionship,
      isFootballSerieB,
      isNba, isRugby, isBasketSerieA,
      cupTabbar,
    } = this.props;
    const { isMobile, currentPhase, currentSubPhase } = this.state;
    const tabs = this.generateRounds(totalDays);
    const isRegular = (isFootballSerieB && currentPhase === 'regularSeason');
    return (
      <React.Fragment>
        {(isVolleyChampionship || isRugby || isBasketSerieA || isFootballSerieB) && <CupCalendarTabbar
          currentPhase={currentPhase}
          currentSubPhase={currentSubPhase}
          phases={cupTabbar.get('phases')}
          dictionary={dictionary}
          isMobile={isMobile}
          isCup
          isVolleyChampionship={isVolleyChampionship}
          isRugby={isRugby}
          isBasketSerieA={isBasketSerieA}
          isFootballSerieB={isFootballSerieB}
        />}
        <span style={this.spanPrevStyle(this.state.liFirst)} className="arrow orange prev icon" onClick={e => this.scroll_button('prev', e)} onKeyPress={e => this.scroll_button('prev', e)}>&#xf123;</span>
        <TabbarWrapper className="TabbarWrapper" justifyContent={(tabs.length > 24 || isTennis) ? false : 'none'} isTennis={isTennis} isSpecialChampionship={isVolleyChampionship || isRugby} isBasketChampionship={isBasketChampionship}>
          {((!isMotorSport && !isVolleyChampionship && !isRugby && !isBasketSerieA && !isTennis && !isFootballSerieB) || (isFootballSerieB && isRegular)) && !isMobile && tabs &&
            <DaysMenu justifyContent={tabs.length > 24 ? 'space-between' : 'flex-start'}>
              {tabs.map(index => (
                <TabPanel
                  label={index}
                  isSelected={currentDay}
                  key={index + 1}
                  index={index}
                  setActiveTab={this.setActiveTab}
                  isCup={isCup}
                  size="14px"
                  bold
                  isSpecialChampionship={isVolleyChampionship || isRugby}
                />
              ))
              }
            </DaysMenu>
          }
          {!isMobile && isVolleyChampionship && currentPhase === 'regular-season' && tabs &&
            <DaysMenu isSpecialChampionship={isVolleyChampionship} justifyContent={tabs.length > 24 ? 'space-between' : 'flex-start'}>
              {tabs.map(index => (
                <TabPanel
                  label={index}
                  isSelected={currentDay}
                  key={index + 1}
                  index={index}
                  setActiveTab={this.setActiveTab}
                  isCup={isCup}
                  size="14px"
                  bold
                  isSpecialChampionship={isVolleyChampionship}
                />
              ))
              }
            </DaysMenu>
          }
          {!isMobile && isRugby && currentPhase === 'regularSeason' && tabs &&
            <DaysMenu isSpecialChampionship={isRugby} justifyContent={tabs.length > 24 ? 'space-between' : 'flex-start'}>
              {tabs.map(index => (
                <TabPanel
                  label={index}
                  isSelected={currentDay}
                  key={index + 1}
                  index={index}
                  setActiveTab={this.setActiveTab}
                  isCup={isCup}
                  size="14px"
                  bold
                  isSpecialChampionship={isRugby}
                />
              ))
              }
            </DaysMenu>
          }
          {!isMobile && isBasketSerieA && currentPhase === 'regularSeason' && tabs &&
            <DaysMenu isSpecialChampionship={isBasketSerieA} justifyContent={tabs.length > 24 ? 'space-between' : 'flex-start'}>
              {tabs.map(index => (
                <TabPanel
                  label={index}
                  isSelected={currentDay}
                  key={index + 1}
                  index={index}
                  setActiveTab={this.setActiveTab}
                  isCup={isCup}
                  size="14px"
                  bold
                  isSpecialChampionship={isBasketSerieA}
                />
              ))
              }
            </DaysMenu>
          }
          {isTennis && tennisTabbar &&
            <ul className="scroll-ul" ref={el => this.ref = el} onScroll={this.handleScroll}>
              {tennisTabbar.map(index => (
                <TabPanel
                  label={index}
                  isSelected={currentTennisPhase}
                  key={index + 1}
                  index={index}
                  setActiveTab={this.setTennisPhase}
                  isCup={isCup}
                  isTennis={isTennis}
                  size="14px"
                  dictionary={dictionary.calendar.tennis.phases}
                />
              ))
              }
            </ul>
          }
          {isMobile && (
            (!isCup && !isMotorSport && !isTennis && !isCycling && !isVolley && !isNba && !isVolleyChampionship && !isBasketSerieA && !isFootballSerieB) ||
            (isVolleyChampionship && currentPhase === 'regular-season') ||
            (isBasketSerieA && currentPhase === 'regularSeason') ||
            (isFootballSerieB && currentPhase === 'regularSeason')
            ) &&
            <Row style={{
              padding: '0px',
              margin: '0px',
              width: '100%',
              overflow: 'visible',
            }}
            >
              <Col
                lg={2}
                md={2}
                sm={2}
                xs={2}
                style={{
                  padding: '0px',
                  margin: '0px',
                  opacity: currentDay === 1 ? 0 : 1,
                }}
              >
                <IconFont
                  className="icon-matchcenter-left-arrow-big"
                  font={30}
                  color="linkColor"
                  withCursor
                  weight="bold"
                  textShadow="0px 1px, 1px 0px, 1px 1px"
                  onClick={() => this.moveLeft(currentDay)}
                />
              </Col>
              <Col
                lg={8}
                md={8}
                sm={8}
                xs={8}
                style={{
                  padding: '0px',
                  margin: '0px',
                  display: 'flex',
                  justifyContent: 'center',
                  overflow: 'visible',
                }}
              >
                <Dropdown
                  options={tabs}
                  selectedOption={currentDay}
                  changeOption={this.setActiveTab}
                  dictionary={dictionary}
                />
              </Col>
              <Col
                lg={2}
                md={2}
                sm={2}
                xs={2}
                style={{
                  padding: '0px',
                  margin: '0px',
                  display: 'flex',
                  justifyContent: 'flex-end',
                  opacity: totalDays === currentDay ? 0 : 1,
                }}
              >
                <IconFont
                  className="icon-matchcenter-right-arrow-big"
                  font={30}
                  color="linkColor"
                  withCursor
                  weight="bold"
                  textShadow="0px 1px, 1px 0px, 1px 1px"
                  onClick={() => this.moveRight(currentDay, totalDays)}
                />
              </Col>
            </Row>
          }
        </TabbarWrapper>
        <span style={this.spanNextStyle(this.state.liLast)} className="arrow orange next icon" onClick={e => this.scroll_button('next', e)} onKeyPress={e => this.scroll_button('next', e)}>&#xf124;</span>
      </React.Fragment>
    );
  }
}

CalendarTabbar.propTypes = {
  // actions: PropTypes.any,
  dictionary: PropTypes.any,
  currentDay: PropTypes.any,
  totalDays: PropTypes.number,
  isCup: PropTypes.bool,
  isFootballChampionship: PropTypes.bool,
  isMotorSport: PropTypes.bool,
  tennisTabbar: PropTypes.any,
  isTennis: PropTypes.bool,
  isCycling: PropTypes.bool,
  isVolley: PropTypes.any,
  isVolleyChampionship: PropTypes.any,
  isBasketChampionship: PropTypes.any,
  isBasketSerieA: PropTypes.any,
  currentTennisPhase: PropTypes.string,
  isNba: PropTypes.bool,
  cupTabbar: PropTypes.any,
  isRugby: PropTypes.bool,
  isFootballExtChampionship: PropTypes.bool,
  isFootballSerieB: PropTypes.bool,
};

export default connect(
  state => ({
    totalDays: state.calendarReducer.getIn(['calendar', 'numberDays']),
    currentDay: state.calendarReducer.getIn(['calendar', 'currentDay']),
    dictionary: state.dictionaryReducer.dictionary,
    tennisTabbar: state.calendarReducer.get('tennisTabbar'),
    currentTennisPhase: state.calendarReducer.get('currentTennisPhase'),
    cupTabbar: state.calendarReducer.get('cupTabbar'),
  }),
  dispatch => ({
    actions: {
      push: url => dispatch(push(url)),
      getCalendar: (sportId, competitionId, day, seasonId) =>
        dispatch({
          type: types.GET_DAY_CALENDAR_REQUEST, sportId, competitionId, day, seasonId,
        }),
      setTennisPhase: phase =>
        dispatch({ type: types.SET_TENNIS_PHASE, phase }),
    },
  }),
)(CalendarTabbar);



// WEBPACK FOOTER //
// ./src/components/CalendarTabbar/index.js